import { render, staticRenderFns } from "./SoftwareListEntry.vue?vue&type=template&id=c3f2efe2&scoped=true&"
import script from "./SoftwareListEntry.vue?vue&type=script&lang=js&"
export * from "./SoftwareListEntry.vue?vue&type=script&lang=js&"
import style0 from "./SoftwareListEntry.vue?vue&type=style&index=0&id=c3f2efe2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3f2efe2",
  null
  
)

export default component.exports